import moment from 'moment'
import { Tooltip } from 'antd'
import styled from 'styled-components/macro'
import {
  CREDIT_REQUEST_DISPLAY,
  formatCreditRequestAmountCell,
} from 'src/utils/creditRequestTableHelpers'

const ResolvedNotesColumns = () => {
  return [
    {
      title: 'PO Number',
      dataIndex: 'PON',
      key: 'PON',
      width: 130,
    },
    {
      title: 'SKU',
      dataIndex: 'SKU',
      key: 'SKU',
      width: 100,
      render: sku =>
        sku === CREDIT_REQUEST_DISPLAY.unknownSku ? <Muted>{sku}</Muted> : sku,
    },
    {
      title: 'Product',
      dataIndex: 'productTitle',
      key: 'product_title',
      width: 180,
      ellipsis: true,
    },
    {
      title: 'Supplier',
      dataIndex: 'supplierTitle',
      key: 'supplier_title',
      width: 120,
      sorter: (a, b) =>
        String(a.supplierTitle)
          .trim()
          .split(' ')
          .join('')
          .localeCompare(String(b.supplierTitle).trim().split(' ').join('')),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
      width: 110,
    },
    {
      title: 'Notes',
      dataIndex: 'notesDisplay',
      key: 'notes',
      width: 140,
      render: (display, record) =>
        record.hasNotes ? (
          <Tooltip title={record.notesFull}>
            <span>{display}</span>
          </Tooltip>
        ) : (
          <Muted>{display}</Muted>
        ),
    },
    {
      title: 'Ordered → credit qty',
      dataIndex: 'qtyDisplay',
      key: 'ordered_credit_qty',
      width: 120,
    },
    {
      title: 'Est. credit',
      dataIndex: 'amount',
      key: 'credit_amount',
      width: 90,
      render: amount => formatCreditRequestAmountCell(amount),
    },
    {
      title: 'Status',
      key: 'credit_supplierStatus',
      width: 140,
      render: (_, record) => (
        <Tooltip
          title={
            record.statusTooltip || 'Status synced from supplier confirmation.'
          }
        >
          <DecisionStatus decision={mapStatusToDecision(record.statusText)}>
            {record.statusText}
          </DecisionStatus>
        </Tooltip>
      ),
    },
    {
      title: 'Source',
      dataIndex: 'source',
      key: 'source',
      width: 100,
    },
    {
      title: 'Requested by',
      dataIndex: 'requestedBy',
      key: 'requested_by',
      width: 120,
      render: (value, record) => value || record.source || '—',
    },
    {
      title: 'Requested',
      dataIndex: 'requestedAt',
      key: 'requested_at',
      width: 110,
      render: dateTime =>
        dateTime ? moment(dateTime).format('DD-MM-YYYY') : '—',
    },
    {
      title: 'Ordered Date',
      dataIndex: 'createdAt',
      key: 'dateOfOrder',
      width: 110,
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      sortDirections: ['ascend', 'descend'],
      render: dateTime => {
        const date = moment(dateTime).format('DD-MM-YYYY')
        return date
      },
    },
  ]
}

const DecisionStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  min-height: 32px;
  width: 100%;
  color: ${props => {
    switch (props.decision) {
      case 'approve_credit':
        return props.theme.colours.lettuceGreen
      case 'replacement_sent':
        return props.theme.colours.lettuceGreen
      case 'reject_request':
        return props.theme.colours.chilliRed
      default:
        return '#666'
    }
  }};
  background-color: ${props => {
    switch (props.decision) {
      case 'approve_credit':
        return `${props.theme.colours.lettuceGreen}15`
      case 'replacement_sent':
        return `${props.theme.colours.lettuceGreen}15`
      case 'reject_request':
        return `${props.theme.colours.chilliRed}15`
      default:
        return '#f5f5f5'
    }
  }};
  border: 1px solid
    ${props => {
      switch (props.decision) {
        case 'approve_credit':
          return props.theme.colours.lettuceGreen
        case 'replacement_sent':
          return props.theme.colours.lettuceGreen
        case 'reject_request':
          return props.theme.colours.chilliRed
        default:
          return '#d9d9d9'
      }
    }};
`

const Muted = styled.span`
  color: #8c8c8c;
`

const mapStatusToDecision = statusText => {
  switch (statusText) {
    case 'CN Approved':
    case 'Supplier approved':
    case 'CN Fulfilled':
      return 'approve_credit'
    case 'CN Rejected':
    case 'Supplier rejected':
      return 'reject_request'
    case 'CN Requested':
    case 'Credit asked':
      return 'pending'
    default:
      return 'pending'
  }
}

export default ResolvedNotesColumns
